import loader from '../../common/loader';
import cookie from '../../common/cookie';
import { loginCookie } from '../login/common';
var jsApi = 'http://mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1';
var qqAppid = '100383922';
var wxAppid = 'wx073f4a4daff0abe8';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'news'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve, reject) {
    if (window.TencentNews) {
      resolve(window.TencentNews);
      return;
    }

    loader.loadScript(jsApi).then(function (isLoad) {
      if (isLoad && window.TencentNews) {
        resolve(window.TencentNews);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.invoke('login', {
      type: 'qqorweixin',
      onCallback: function onCallback() {
        location.reload();
      }
    });
  })["catch"](function () {});
};

var loginByWX = function loginByWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.invoke('login', {
      type: 'weixin',
      onCallback: function onCallback() {
        location.reload();
      }
    });
  })["catch"](function () {});
};

var loginByQQ = function loginByQQ() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.invoke('login', {
      type: 'qq',
      onCallback: function onCallback() {
        location.reload();
      }
    });
  })["catch"](function () {});
};

var setAppCookie = function setAppCookie() {
  console.log('beforeSetCookie');
  return new Promise(function (resolve, reject) {
    loadJsApi().then(function (JsBridge) {
      JsBridge.invoke('getUserInfo', {
        onCallback: function onCallback(info) {
          if (info) {
            console.log('getUserInfo返回', info);
            var loginway = info.account ? info.account : null;
            var logintype = cookie.get('logintype');
            var quin = cookie.get('luin');
            var qskey = cookie.get('lskey');
            var mobileqopenid = cookie.get('open_openid');
            var mobileqtoken = cookie.get('open_access_token');
            var wopenid = cookie.get('openid');
            var waccesstoken = cookie.get('access_token');

            if (loginway === 'qq' && logintype === '0' && qskey) {
              loginCookie.setQQ({
                uin: quin,
                skey: qskey
              }, 7200);
              loginCookie.clearQQ(['appid', 'acctype', 'access_token', 'openid', 'refresh_token', 'IED_LOG_INFO2']);
            } else if (loginway === 'qq' && logintype === '11' && mobileqopenid && mobileqtoken) {
              window.iUseQQConnect = 1;
              loginCookie.setLocal({
                acctype: 'qc',
                appid: qqAppid,
                openid: mobileqopenid,
                access_token: mobileqtoken
              }, 7200);
              loginCookie.clearQQ();
            } else if (loginway === 'weixin' && logintype === '1') {
              loginCookie.setQQ({
                acctype: 'wx',
                appid: wxAppid,
                openid: wopenid,
                access_token: waccesstoken
              }, 7200);
              loginCookie.clearQQ(['uin', 'skey', 'IED_LOG_INFO2']);
            }

            resolve();
          } else {
            reject();
          }
        }
      });
    })["catch"](function () {
      reject();
    });
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    var logintype = cookie.get('logintype');

    if (logintype === '1') {
      resolve('wx');
    }

    if (logintype === '11') {
      resolve('qc');
    }

    if (logintype === '0') {
      resolve('pt');
    }

    resolve(null);
  });
};

var logout = function logout() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.invoke('logout', {
      onCallback: function onCallback() {
        console.log('logout');
      }
    });
  })["catch"](function () {});
};

var news = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default news;